@for (toast of toastService.toasts(); track toast) {
<ngb-toast [class]="toast.classname" [autohide]="toast.autoclose !== false"
	[delay]="toast.delay !== undefined ? toast.delay : 5000" (hidden)="toastService.remove(toast)">
	<div style="display: flex; justify-content: space-between; align-items: center;">
		<span>{{toast.message}}</span>
		<button type="button" class="btn-close ms-2" aria-label="Close" (click)="toastService.remove(toast)"></button>
	</div>
</ngb-toast>
}